import { render } from "./PackageView.vue?vue&type=template&id=69c6302d"
import script from "./PackageView.vue?vue&type=script&lang=js"
export * from "./PackageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__